import { MEDIA_NOW_PREFIX, MEDIA_NOW_SUFFIX } from './videoUrlComm';

export const ALLETRA9k_VIDEO_URL = Object.freeze({
  FACTORY_UNBOX_STEP1:
    MEDIA_NOW_PREFIX + 'PORMSJFJMJ&ek=dvQF3STJ' + MEDIA_NOW_SUFFIX,
  FACTORY_UNBOX_STEP2:
    MEDIA_NOW_PREFIX + 'KKSPQMMKIF&ek=Em1ljFyY' + MEDIA_NOW_SUFFIX,
  FACTORY_UNBOX_STEP3:
    MEDIA_NOW_PREFIX + 'RRRLMKKFDM&ek=UgFDhOxM' + MEDIA_NOW_SUFFIX,

  FIELD_UNBOX: MEDIA_NOW_PREFIX + 'LLOJMPEFMM&ek=T3WhNpxT' + MEDIA_NOW_SUFFIX,
  FIELD_INSTALL_STEP1:
    MEDIA_NOW_PREFIX + 'PQSJOLMMJF&ek=8YpvGVxN' + MEDIA_NOW_SUFFIX,
  FIELD_INSTALL_STEP2:
    MEDIA_NOW_PREFIX + 'LLMORMLIJJ&ek=QapMJMyV' + MEDIA_NOW_SUFFIX,
  FIELD_INSTALL_STEP3:
    MEDIA_NOW_PREFIX + 'LOLQMOJHMG&ek=ayDhDkvL' + MEDIA_NOW_SUFFIX,
  FIELD_INSTALL_STEP4:
    MEDIA_NOW_PREFIX + 'PPSJMKKGGK&ek=w3HIikzN' + MEDIA_NOW_SUFFIX,

  FIELD_CABLE_STEP1:
    MEDIA_NOW_PREFIX + 'NQJNJOIFLE&ek=c4zqMNH4' + MEDIA_NOW_SUFFIX,
  FIELD_CABLE_STEP2:
    MEDIA_NOW_PREFIX + 'KQSPMKEDIM&ek=vySwFwtv' + MEDIA_NOW_SUFFIX,
  FIELD_CABLE_STEP3:
    MEDIA_NOW_PREFIX + 'OSRPPOMFHG&ek=MY0mZHgb' + MEDIA_NOW_SUFFIX,
  FIELD_CABLE_STEP4:
    MEDIA_NOW_PREFIX + 'LJQKKSEEGF&ek=qRMK4bkF' + MEDIA_NOW_SUFFIX,
  FIELD_CABLE_STEP5:
    MEDIA_NOW_PREFIX + 'QNOPRNJJEJ&ek=hyaXJwQQ' + MEDIA_NOW_SUFFIX,

  FACTORY_CABLE_STEP1:
    MEDIA_NOW_PREFIX + 'OSRPPOMFHG&ek=MY0mZHgb' + MEDIA_NOW_SUFFIX,
  FACTORY_CABLE_STEP2:
    MEDIA_NOW_PREFIX + 'LJQKKSEEGF&ek=qRMK4bkF' + MEDIA_NOW_SUFFIX,
  FACTORY_CABLE_STEP3:
    MEDIA_NOW_PREFIX + 'QNOPRNJJEJ&ek=hyaXJwQQ' + MEDIA_NOW_SUFFIX,

  POWERUPANDINIT_POWER:
    MEDIA_NOW_PREFIX + 'SLROMNIJHM&ek=MkP8kdt7' + MEDIA_NOW_SUFFIX,
  POWERUPANDINIT_PREREQ:
    MEDIA_NOW_PREFIX + 'PJMNNOGDGG&ek=Qqy7JXVo' + MEDIA_NOW_SUFFIX,
  POWERUPANDINIT_INIT:
    MEDIA_NOW_PREFIX + 'RKRLLSFMKK&ek=UHlZewEP' + MEDIA_NOW_SUFFIX,
  CONNECTARRAY: MEDIA_NOW_PREFIX + 'LRMPOSEKFF&ek=272I4fRG' + MEDIA_NOW_SUFFIX,
  SETUPARRAY: MEDIA_NOW_PREFIX + 'RJONMKIGJE&ek=FbOOJgao' + MEDIA_NOW_SUFFIX,
  // key: MEDIA_NOW_PREFIX + 'LNPNNLDGHJ&ek=A529hlM' + MEDIA_NOW_SUFFIX,
  // key2: MEDIA_NOW_PREFIX + 'LNPNNLDGHJ&ek=A529hlM' + MEDIA_NOW_SUFFIX,
  // FIELD_INSTALL_STEP1
  // FACTORY_UNBOX_STEP1: '//media.now.hpe.com/EmbeddedPlayer.ashx?key=LNPNNLDGHJ&ek=A529hlM3&pb=0&play=1&width=100%&height=100%&xdomain=1&targetdivid=playerDiv',
});
